import { CLASS_NAME_DEFAULT } from "../../../../constants"
import Form from "../../../form"
import If from "../../../if"

type Props = {
  id?: string
  globalFilter: string
  searchPlaceholder: string
  onSearch: (value: string | number) => void
  children?: React.ReactNode
  className?: string
  searchClassName?: string
}

const SearchBar = ({
  id,
  globalFilter,
  onSearch,
  searchPlaceholder,
  children,
  className = CLASS_NAME_DEFAULT,
  searchClassName = "lg:min-w-[20rem] text-sm"
}: Props) => (
  <div
    className={`${className} align-middle items-center bg-white gap-1 lg:gap-3`}
  >
    <If
      condition={!!id}
      then={
        <label className="sr-only" htmlFor={id}>
          {searchPlaceholder}
        </label>
      }
    />
    <Form.SearchInput
      wrapperClassName="w-full flex-1 lg:w-auto lg:mb-0"
      placeholder={searchPlaceholder}
      value={globalFilter ?? ""}
      onSearch={onSearch}
      className={searchClassName}
      id={id}
    />
    <div className="flex align-center items-center lg:flex-1">{children}</div>
  </div>
)

export default SearchBar
